<template>
  <div v-if="loading" class="overlay">
    <div class="spinner" :style="spinnerStyle"></div>
    <slot>{{ $t("favorites.loading") }}</slot>
  </div>
  <template v-else>
    <div class="hero bg-light-1">
      <div class="product-list-page container pt-4">
        <div class="section-header-products-prefered text-center my-4">
          <h1 class="title-page" v-html="$sanitize.sanitizeI18nContent($t('home_vet.title'))"></h1>
          <p>{{ $t("home_vet.subtitle") }}</p>
        </div>
        <SearchProduct />

        <div v-if="prefered_products?.length" class="row justify-content-center prefered-products-section">
          <!-- <div v-if="prefered_products.length === 0" class="empty">{{ $t("products.empty") }}</div> -->
          <div class="w-80">
            <PreferedProducts v-if="prefered_products.length" :products="prefered_products" />
          </div>
        </div>
      </div>
    </div>

    <div class="list-block bg-white">
      <div class="access-list container">
        <div class="row align-items-center">
          <div class="content col-12">
            <AccessRapid @open-drawer-raccourci="OpenDrawer" />
          </div>
        </div>
      </div>
    </div>
    <div class="gamme-block bg-light-1">
      <div class="gammes-list-product container">
        <div class="row">
          <div class="content col-12">
            <GammeProduct v-if="gammes_product.length" :GammeProduct="gammes_product" />
          </div>
        </div>
      </div>
    </div>
    <div class="service-list">
      <div class="container">
        <div class="content col-12">
          <Service />
        </div>
      </div>
    </div>
    <div class="question-list bg-light-1">
      <div class="container">
        <div class="content col-12">
          <Question />
        </div>
      </div>
    </div>
    <DrawerSidebar v-if="DrawerRaccourci" @close-drawer-raccourci="CloseDrawer" />
  </template>
</template>

<script>
  import SearchProduct from "@/components/SearchProduct.vue";
  import PreferedProducts from "@/components/products/PreferedProducts.vue";
  import AccessRapid from "@/components/AccessRapid.vue";
  import DrawerSidebar from "@/components/DrawerSidebar.vue";
  import GammeProduct from "@/components/GammeProduct.vue";
  import Service from "@/components/Service.vue";
  import Question from "@/components/Question.vue";
  import { useProductsStore } from "@/stores/productsStore";
  import { useShortcutsStore } from "@/stores/shortcutsStore";

  export default {
    name: "HomePageVet",
    components: {
      SearchProduct,
      PreferedProducts,
      AccessRapid,
      DrawerSidebar,
      GammeProduct,
      Service,
      Question,
    },
    computed: {
      spinnerStyle() {
        return {
          width: this.size,
          height: this.size,
          borderColor: `${this.color} transparent transparent transparent`,
        };
      },
      products() {
        var products_variants = [];
        this.productsStore.allProducts.map(prod => {
          if (prod.variantsDetails) {
            prod.variantsDetails.map(variant => {
              variant.gamme = prod.gamme;
              variant.image = prod.imagesDetails ? prod.imagesDetails[0].path : "";
              const isPrecommande = 
                (variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date()) ||
                (prod.datePrecommandeSupplyvetEsupplyvet && new Date(prod.datePrecommandeSupplyvetEsupplyvet) > new Date());
              if (variant.inStock || isPrecommande) products_variants.push(variant);
            });
          }
        });
        return products_variants;
      },
      prefered_products() {
        return this.productsStore.favorites;
      },
      CountFavorite() {
        return this.productsStore.countFavorite;
      },
      gammes_product() {
        return this.productsStore.allProducts;
      },
      loading() {
        return this.productsStore.loading;
      },
      error() {
        return this.productsStore.error;
      },
    },
    data() {
      return {
        productsStore: useProductsStore(),
        shortcutsStore: useShortcutsStore(),
        size: "50px",
        color: "#3498db",
        DrawerRaccourci: false,
      };
    },
    mounted() {
      if (this.productsStore.allProducts.length === 0) {
        this.productsStore.fetchProducts();
      }
      this.shortcutsStore.fetchShortcuts();
      console.log("Initial countFavorite:", this.productsStore.countFavorite);
    },
    created() {
      this.productsStore.fetchAllProducts();
    },
    watch: {
      CountFavorite(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.productsStore.fetchProducts();
        }
      },
    },
    methods: {
      OpenDrawer() {
        this.DrawerRaccourci = true;
      },
      CloseDrawer() {
        this.DrawerRaccourci = false;
        if (this.shortcutsStore.selectedShortcuts.length === 0) {
          this.shortcutsStore.reset();
        }
      },
    },
  };
</script>

<style scoped>
  .product-list-page {
    text-align: center;
    max-width: 100%;
    padding-bottom: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .gammes-list-product {
    padding: 1.5rem;
    text-align: center;
    max-width: 100%;
  }

  .service-list {
    padding: 2rem 1rem;
    text-align: center;
    background: #fff;
    max-width: 100%;
  }
  .access-list {
    padding: 5rem 1rem 2rem;
    text-align: center;
    background: #fff;
    max-width: 100%;
  }
  .question-list {
    padding: 2rem 1rem;
    text-align: center;
    background: #eff1f7;
    max-width: 100%;
  }

  .section-header-products-prefered {
    text-align: center;
    font-style: normal;
    position: relative;
    margin-bottom: 2rem;
  }

  .title-page {
    font-size: clamp(2rem, 5vw, 3.5rem);
    text-align: center;
    font-weight: bold;
    color: #1e347d;
    line-height: 1.2;
  }

  .title-page p {
    font-size: clamp(1rem, 2.5vw, 1.125rem);
  }

  label {
    font-size: clamp(0.875rem, 2vw, 1rem);
    font-weight: normal;
  }

  span {
    color: #1e347d;
  }

  .w-80 {
    width: 100%;
    max-width: 80rem;
  }

  .error,
  .empty {
    color: #777;
    font-size: clamp(1rem, 2.5vw, 1.2rem);
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  /* Responsive PreferedProducts section */
  .prefered-products-section {
    width: 100%;
    margin: 0 auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (max-width: 768px) {
    .prefered-products-section {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    .w-80 {
      max-width: 100%;
      width: 100%;
      padding: 0;
    }
  }

  @media (max-width: 576px) {
    .prefered-products-section {
      padding-left: 0;
      padding-right: 0;
    }
    .w-80 {
      max-width: 100%;
      width: 100%;
      padding: 0;
    }
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: clamp(1rem, 2.5vw, 1.2rem);
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    .product-list-page {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .gammes-list-product {
      padding: 1rem;
    }

    .service-list,
    .access-list,
    .question-list {
      padding: 1.5rem 0.5rem;
    }

    .title-page {
      font-size: clamp(1.5rem, 4vw, 2.5rem);
    }
  }

  @media (max-width: 576px) {
    .product-list-page {
      padding-bottom: 2rem;
    }

    .section-header-products-prefered {
      margin-bottom: 1.5rem;
    }
  }
</style>
